export const LABELS_DASHBOARD = {
	greetingMorning: "Доброго ранку,",
	greetingDay: "Доброго дня,",
	greetingEvening: "Доброго вечора,",
	withUs: "з нами {{duration}}",
	accountSince: "акаунт з {{date}}",
	balance: "Баланс",
	balanceOf: "з {{value}} поповнення",
	devicesOnline: "ТЗ онлайн",
	onlineShare: "{{percent}}% флоту на зв'язку",
	voyagesOnRoute: "Рейси на маршруті",
	voyagesProblems: "{{notInRoute}} не на маршруті · {{gps}} збій GPS",
	activity: "Активність пристроїв",
	total: "усього {{value}}",
	online: "онлайн",
	activityHint: "Клік по сектору, стовпчику чи рядку легенди відкриває список ТЗ",
	donut: "Кільце",
	bars: "Стовпчики",
	short: {
		totalOnline: "Онлайн",
		totalOneHour: "< 1 год",
		totalLastDay: "< доби",
		totalLastWeek: "< тижня",
		totalLastMonth: "< місяця",
		totalBeforeLastMonth: "> місяця",
		totalNotConnected: "Не було",
		totalInactive: "Не обсл.",
	},
	news: "Новини",
	sessions: "Входи в акаунт",
	user: "Користувач",
	loginAt: "Вхід",
	session: "Сеанс",
	ip: "IP",
	today: "сьогодні",
	yesterday: "вчора",
	settings: "Мої налаштування",
	timeZone: "Часовий пояс",
	startPage: "Стартова сторінка",
	save: "Зберегти",
	saved: "Налаштування збережено",
	saveError: "Не вдалося зберегти налаштування",
	search: "Пошук",
	empty: "Немає записів",
}
